<ms-widget-slot
    msModalDialogContainer
    *ngIf="content$ | async as vm"
    [widget]="vm.widgets"
    [page]="vm.page"
    [layoutTemplate]="vm.layoutTemplate"></ms-widget-slot>
